import * as React from "react";
import Section from "../../../components/atoms/Section";
import { SwooshSVG } from "../../JadwalPertandingan/JadwalPertandingan.styled";
import { func } from "../../../utils";
import useWindowSize from "../../../hooks/useWindowSize";
import { ScheduleCardList, ScheduleTabs } from "./components";
import { useFetchEventSeriesDetail, useFetchMatches } from "../../../networks";
import { NewFooter } from "../../../components";
import {
  TabsWrapper,
  ContentWrapper,
  InnerContentWrapper,
  PageTitle,
  ScheduleCardWrapper,
  TitleWrapper,
  StreamingWrapper,
  StreamingCard,
} from "./JadwalPertadingan.styled";
import moment from "moment";
import { usePageContextFunction } from "../../../context/PageContext";
import { ScheduleCardProps } from "./components/Schedule/Schedule";
import StatisticDetail from "./components/StatisticDetail";
import Show from "../FormRegistration/components/Show";
import { EmptyStateWrapper } from "../GalleryDetail/GalleryDetail.styled";
// @ts-ignore
import EmptyState from "../../../components/molecules/v2/TimelineSection/assets/empty-state-mobile.png";
// @ts-ignore
import EmptyStateDesktop from "../../../components/molecules/v2/TimelineSection/assets/empty-state-desktop.png";

const JadwalPertandinganSocPage = () => {
  const { setOpenPopUp: toglePopUp, setCity } = usePageContextFunction();

  const { size } = useWindowSize();
  // @ts-ignore
  const isMobileView = (size?.width || 0) <= 830;

  const [activeIndex, setActiveIndex] = React.useState<number>(0);
  const [activeDate, setActiveDate] = React.useState<string>();

  const { data: dataSeriesDetailRaw } = useFetchEventSeriesDetail("soc");

  const dataSeriesDetailRegionId =
    (
      dataSeriesDetailRaw?.data?.data?.eventSeries?.[0]?.region_series || []
    )?.find((item) => item?.is_soc)?.id || 54;

  const {
    data: dataJadwalPertandinganRaw,
    isFetching,
    isRefetching,
  } = useFetchMatches({
    region_id: dataSeriesDetailRegionId,
  });

  const isFetchingData = isFetching && !isRefetching;

  const dataJadwalPertandingan = dataJadwalPertandinganRaw?.data?.data ?? [];

  const dataDateList = Object.keys(
    dataJadwalPertandingan?.futsalSMA || {}
  )?.filter((item) => item !== "");
  const dataOptions = (() => {
    const list = dataDateList || [];
    const sliceStart = Math.max(list.length - 3, 0);
    return list.slice(sliceStart).map((date, idx) => ({
      index: idx,
      date,
    }));
  })();

  const dataByActiveDate =
    dataJadwalPertandingan?.futsalSMA?.[activeDate || ""];

  const handleChangeTab = (index: number) => {
    setActiveIndex(index);
    setActiveDate(dataDateList?.[index]);
  };

  const handleOpenStatisticModal = (data: ScheduleCardProps) => {
    // @ts-ignore
    toglePopUp({
      state: true,
      classNamePopupParent:
        "!top-0 top-[16px] !bottom-0 inline overflow-y-hidden max-h-screen",
      classNamePopupContent: `md:bg-[#151E29] bg-[#1F2D3D] static max-h-none h-screen rounded-none ${
        isMobileView ? "mt-0" : "mt-[72px]"
      }`,
      classNamePopupContainer:
        "md:bg-[#151E29] bg-[#1F2D3D] shadow-none w-[100vw] p-0 rounded-none",
      closePosition: !isMobileView ? "outside" : "inside",
      iconCloseClassname: "md:top-0 top-[16px] right-[16px] absolute !h-[24px]",
      typePopUp: "custom-children",
      invertCloseColor: true,
      isDisableHandleTouchMove: true,
      children: <StatisticDetail data={data} />,
    });
  };

  const initialSetRef = React.useRef(false);

  React.useEffect(() => {
    if (initialSetRef.current) return;
    if (!dataDateList || dataDateList.length === 0) return;

    const today = moment().startOf("day");
    let nearestIdx = 0;
    let minDiff = Number.POSITIVE_INFINITY;

    dataDateList.forEach((date, idx) => {
      const d = moment(date).startOf("day");
      const diff = Math.abs(d.diff(today, "days"));
      if (diff < minDiff) {
        minDiff = diff;
        nearestIdx = idx;
      }
    });

    setActiveIndex(nearestIdx);
    setActiveDate(String(dataDateList[nearestIdx]));
    initialSetRef.current = true;
  }, [dataDateList]);

  React.useEffect(() => {
    // @ts-ignore
    setCity("soc");
  }, []);

  return (
    <React.Fragment>
      {/* @ts-ignore */}
      <Section id="jadwal-pertandingan" height={"auto"} overflowY={"auto"}>
        <SwooshSVG
          src={func.getStaticImg(
            isMobileView
              ? "/bg/sharpswoosh-soc-m.svg"
              : "/bg/sharpswoosh-soc.svg"
          )}
        />
        <ContentWrapper
          style={{
            background: `${"#1F2D3D"} ${`url(${func.getStaticImg(
              "/bg/brush-woosh.svg"
            )})`} center 30% no-repeat`,
          }}
        >
          <InnerContentWrapper>
            <TabsWrapper>
              <TitleWrapper>
                <PageTitle>Jadwal & Hasil Pertandingan</PageTitle>
              </TitleWrapper>
              <div className={isMobileView ? "px-[20px]" : ""}>
                <ScheduleTabs
                  activeIndex={activeIndex}
                  options={dataOptions}
                  onChangeTab={handleChangeTab}
                />
              </div>
              <StreamingWrapper>
                <StreamingCard
                  onClick={() => {
                    window.open(
                      "https://youtube.com/live/4AkXfz2sxCI?feature=share",
                      "_blank"
                    );
                  }}
                  style={{
                    background: `url(${func.getStaticImg(
                      "illustration/lapangan2.png"
                    )})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                  }}
                />
                <StreamingCard
                  onClick={() => {
                    window.open(
                      "https://youtube.com/live/4AkXfz2sxCI?feature=share",
                      "_blank"
                    );
                  }}
                  style={{
                    background: `url(${func.getStaticImg(
                      "illustration/lapangan1.png"
                    )})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                  }}
                />
              </StreamingWrapper>
            </TabsWrapper>
            <ScheduleCardWrapper>
              <Show
                when={dataByActiveDate?.length > 0}
                fallbackComponent={
                  <EmptyStateWrapper style={{ left: 0 }}>
                    {isMobileView ? (
                      <img
                        src={EmptyState}
                        alt={"empty-state"}
                        className="h-[484px]"
                      />
                    ) : (
                      <img src={EmptyStateDesktop} alt={"empty-state"} />
                    )}
                  </EmptyStateWrapper>
                }
              >
                <ScheduleCardList
                  isLoading={isFetchingData}
                  onClick={handleOpenStatisticModal}
                  data={dataByActiveDate}
                />
              </Show>
            </ScheduleCardWrapper>
          </InnerContentWrapper>
        </ContentWrapper>
      </Section>
      {/* @ts-ignore */}
      <NewFooter />
    </React.Fragment>
  );
};

export default JadwalPertandinganSocPage;
